import api from "@/common/js/api";
import { ElMessageBox } from "element-plus";
export default {
  namespaced: true,
  state: () => ({
    formItems: [],
    host: "",
    $vm: null,
  }),
  mutations: {
    setFormItems(state, formItems) {
      state.formItems = formItems;
    },
    setVm: (state, vm) => {
      state.$vm = vm;
    },
  },
  getters: {
    showComponentMail: (state) => {
      if (state.$vm) {
        // console.log(state.$vm.showComponent);
        return state.$vm.showComponent;
      } else {
        return false;
      }
    },
  },
  actions: {
    requestNoticeData($store, formData) {
      return new Promise((resolve, reject) => {
        if (!$store.state.host) {
          api.get("/static/config/electronicServerUrl.json").then((response) => {
            $store.state.host = response.reportServer;
            var url = "/Guarantee/getNoticeData";
            api.form($store.state.host + url, formData).then((res) => {
              if (res.code == 200) {
                resolve(res.data);
              } else {
                // ElMessageBox({
                //   type: "error",
                //   title: "报错提示",
                //   message: res.msg || "接口报错",
                //   showCancelButton: true,
                //   confirmButtonText: "确定",
                //   cancelButtonText: "取消",
                // });
              }
            });
          }).catch(e => null);
        } else {
          var url = "/Guarantee/getNoticeData";
          api.form($store.state.host + url, formData).then((res) => {
            if (res.code == 200) {
              resolve(res.data);
            }
          });
        }
      });
    },
    pushNoticeData($store, formData) {
      return new Promise((resolve, reject) => {
        var url = "/Guarantee/pushNoticeData";
        api.form($store.state.host + url, formData).then((res) => {
          resolve(res.data);
          if (res.code == 200) {
          } else {
            // ElMessageBox({
            //   type: "error",
            //   title: "报错提示",
            //   message: res.msg || "接口报错",
            //   showCancelButton: true,
            //   confirmButtonText: "确定",
            //   cancelButtonText: "取消",
            // });
          }
        });
      });
    },
  },
};
